module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("SOMETHING WAS")]), _vm._v(" rotten.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I didn’t mean in a figurative sense. I meant something smelled like it was decaying.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shit,” I muttered. I stood at the door of my antique shop, hand to my nose.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tupperware. It had to be an old lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was a wintry, miserable Tuesday in New York City, two weeks’ shy of Christmas. The snow was coming down heavily at seven in the morning, blanketing the city and producing an eerie, muted effect. I had shown up early to my business, Snow’s Antique Emporium, in downtown Manhattan, with the intention of going through some newly acquired inventory. Instead, I was dripping melted snow onto the welcome mat and trying to pinpoint that god-awful stench.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I quickly hung up my jacket and hat and changed out of my boots into an old pair of worn loafers beside the door. I ran my fingers through my unruly hair and smoothed the front of my sweater while walking down the tiny, crowded aisles. I stopped to turn on old lamps as I followed the smell. The glow of the lights was subdued, creating a cavernous look for the shop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("At the counter that had an old brass register on it, I took the step up onto the elevated floor, scanning the shop. It smelled even worse here. I reached into my sweater pocket and replaced my sunglasses with black-framed reading glasses. Turning on the bank lamp, I winced and looked away from the light.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I stared at the door standing ajar to my right. It was a tiny little closet that served as an office, with a computer and chair and mini fridge all tucked away for my use.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Does forgotten Thai food smell like death after two days?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I walked in, opened the fridge, and hesitantly sniffed a few cartons. Okay, I needed to do some serious cleaning, but what seemed like a half-eaten burrito was not the source of the odor.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I walked back to the register, groaning loudly as I looked around. Something had to have died—a rat, perhaps? I cringed at the thought of finding a New York City rodent in my shop, but I crouched down and started shoving aside bags and boxes used at checkout while I looked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The front door opened, the bell chiming overhead. “Good morn—what’s that smell?” my assistant, Max, called. “Sebastian?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Over here,” I grumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Max Ridley was a sweet guy, a recent college grad with an art degree he realized rather too quickly wasn’t going to pay his rent. He was smart and knew his history. I’d hired him the same day he’d come in to fill out an application. Max was tall and broad-shouldered—a handsome young man who was maybe bisexual or maybe just out to experience it all. I’d heard enough stories over morning coffee, reading mail, and pricing antiques to know Max’s preference seemed to be mostly anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Call me old-fashioned, but I’m a one-man sort of guy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“God, the weather sucks today. Do you think it’ll be busy?” Max asked as he strolled through the shop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Usually is,” I said, looking up over the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What did you leave sitting out?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nothing. I think a rat died or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can I turn on more lights? It’ll be easier to find.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I already have a headache,” I said absently. I crouched back down to finish moving out the supplies from under the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I was born with achromatopsia, which means I can’t see color. We have two types of light receptor cells in our eyes, cones and rods. Cones see color in bright light, rods see black and white in low light. My cones don’t work. At all. The world to me exists only in varying shades of gray, and I have a difficult time seeing in places with bright lights because the rods aren’t meant for daylight purposes. Usually I wear sunglasses or my special red-tinted contacts as an extra layer of protection….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I forgot my contacts. And the snow was too bright.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Even for shades?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Damn")]), _vm._v(", where is that smell coming from?” I asked while standing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Max motioned to the register. “Smells the worst right here.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah.” I walked back to the steps and promptly fell forward when the creaky floorboard underfoot skidded sideways.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Max lunged out and grabbed me before I could plant my face on the floor. He held me tight, my face smooshed against his armpit. “Did you have another fight with Neil last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why?” I asked as I pulled myself free from his hold.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’ve got some bad mojo following you around this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It wasn’t a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("fight")]), _vm._v(". It was—you know, I’m not talking about it while the smell of rot continues to permeate my shop.” I turned back to the step and bent to examine the floorboard that had become free.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bad idea. The stench of decay filled my nostrils, and I fought back the urge to gag.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I think you found it,” Max muttered, looking down over my shoulder. “I’ll get a bag.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I nodded silently, holding my nose while I looked into the opening under the floor. It—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("the thing")]), _vm._v("—wasn’t dark, like a dead rat. It didn’t appear to have fur, but I’d be lying if I said I had great vision when it came to close-up details.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Max? Come here.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” His voice came from the office before he joined me with a garbage bag. “What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Look in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh come on. You don’t pay me enough for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, I mean, I don’t think that’s a rat.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Max got down on one knee and glanced inside before quickly pulling back. “What the hell!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I stared at the floor. “Tear up the planks! Here, here!—It is the beating of his hideous heart!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Poe,” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“God, you’re so weird, Seb,” Max muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What else am I supposed to say?” I asked, pointing at the rotting flesh. “It’s a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("heart")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who did you kill?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll call the cops.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("HAVING TO")]), _vm._v(" explain to the dispatcher that I needed police not because of a dead body, but there was a body out there missing an essential part, was certainly the strangest thing I’d done in some time. I’ll admit the situation piqued my interest, but there are 101 things in life I simply don’t have the patience for, and finding someone else’s rotting heart in the floorboards of my shop just about topped the list.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Max sprayed nearly an entire can of air freshener while we waited after the phone call. “Smells like fresh laundry,” he stated while reading the can.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh good,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Laundry and "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("death")]), _vm._v(",” Max corrected after a pause. “Sometimes "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I")]), _vm._v(" want to die instead of dragging my dirty clothes to the Laundromat.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Max.” I sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I crossed my arms, looking toward the back of the shop at the piles of boxes that had been left there. When new inventory arrived, it needed to be carefully inspected, priced, and arranged in the shop. If it was too priceless for the shop, it needed to be listed for auction, not sitting in a damn box on the floor. Those and several more were collecting dust in my apartment. So much for finally getting around to it all this morning.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("There was a rap at the door, and I walked over to unlock it. “Good morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sir,” one of the uniformed officers said. “We got a call—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“There’s a body part in my floor,” I quickly answered, leading them through the aisles toward the register.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was pretty clear they’d been sent to dispel whatever fear or confusion the dispatcher thought I was experiencing, yet they followed without complaint or comment. The first officer removed his cap as he bent down to the opening I pointed at. He only glanced inside before shaking his head and rising.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Brigg,” he spoke to his partner, and the woman approached.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I watched them confer briefly before she got on her radio. “So,” I said, “do we need some hazmat team or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can I get your name, sir?” the officer replied as he removed a notepad from his belt.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sebastian Snow.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And do you run this business?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Own the building?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No. I wish.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He looked up. “Approximately when did you suspect something was in the store?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You mean—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("that")]), _vm._v("?” I asked while looking down at the floor. “When I opened the door this morning, I could smell it. It was about seven.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Does anyone else have access to the store?” The officer looked over my shoulder at Max.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Max has keys, but only I and—only I have access to the security code,” I explained.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The truth was, my partner of four years, Neil Millett, also had keys and the code, but mentioning his name around cops was a bit tricky. He was a detective with the NYPD’s forensic investigations unit, and very much in the closet. So much so that the only people who knew we were living together were Max and my father. Neil didn’t want other officers knowing he was gay, and when I was twenty-nine with a heart all aflutter for a sexy detective, I didn’t mind. Now I was thirty-three, and it was wearing me out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The officer wrote down a few notes. “Do you have cameras? You have a lot of expensive-looking items in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I have one, but it’s been on the fritz for the past month.” I had been suffering from a lack of mental stamina lately and just hadn’t found the energy to give a shit about a number of things, camera included.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It wasn’t like me. I knew that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil made a point of bringing up my recent attitude. A lot. It only pissed me off more.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The officer continued taking down my contact information, then asked for Max’s as well. A few more basic questions followed, and then Brigg led two plain-clothed cops from the front door toward us. Glancing around the now congested aisle, I saw yet another woman entering, carrying some sort of medical kit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The overhead lights, which I never used, were switched on without warning, and the entire room was washed out of sight. I hastily covered my eyes and turned away, stumbling and reaching around the countertop. Max went to the other corner to avoid the police and the heart, grabbed my sunglasses, and handed them over just as someone spoke my name.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mr.… Snow, is it?” a woman asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turning as I put on my shades, I was confronted with the two new cops. The woman who spoke was maybe my age and couldn’t have been an inch over five feet, with a strong build and closely cropped hair. The other, a man, was tall and big and filled out his suit with nothing but muscle. He looked older than Neil, who was thirty-seven. His hair was light, so I guessed it was what I have been told is blond.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I squinted to better study him. He had freckles. A lot, actually. I kind of had a thing for guys with freckles. Cheeks, nose, forehead—he had freckles all over, and it gave him a sort of sweet look initially. Maybe his hair was red instead.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sebastian Snow,” I agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The woman took the lead, extending her hand to shake. “I’m Detective Quinn Lancaster, and this is my partner, Detective Calvin Winter.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Uh, hi.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lancaster smiled. “How’s business been, Mr. Snow?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Fine,” I said, confused. It was strange to be looking down at such a short figure of authority, but she had an air of confidence I wasn’t willing to question.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What can you tell me about your clientele?” Lancaster continued.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I shrugged while crossing my arms. “Regular folks, some with big money, some looking for curiosities. Corporate types, hipsters—I get a little of everyone in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She nodded. “Would it be all right if you removed your sunglasses, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lancaster looked up at Winter briefly before asking, “Why’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I have a light sensitivity. If you turn the overheads off, I will,” I said while pointing up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Winter turned away and gave an order to one of the uniformed officers. The lights died and the shop was once again illuminated by the strategically placed lamps.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Better?” Lancaster asked, her tone not mocking or unkind.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I pulled the sunglasses back to rest on my head as I put my regular glasses back on. “Thank you,” I said briskly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That’s called photophobia, isn’t it?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I have achromatopsia.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I see.” She didn’t bother for more details. “Has anything out of the ordinary happened in the past few weeks?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nope.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lancaster frowned. “Who found the body part?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I did, when I came in. I smelled something awful and started looking for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Have there been any break-ins or stolen items?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” I said. “What’s this about? I’m assuming something bigger is at play here, otherwise you two wouldn’t be grilling me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why do you say that?” Lancaster asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I live with a cop” was what I wanted to say. Four years of stories from Neil had, admittedly, given me an unhealthy interest in "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("whodunit")]), _vm._v(" mysteries.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Instead, I just shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Winter spoke for the first time. “Do you know Bond Antiques?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, on Bond Street and Lafayette,” I confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How is your relationship with the owner?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I fail to see what that has to do with anything,” I responded. “Mike Rodriguez and I have known each other for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How do you get along?” Winter asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He’s competition,” I stated. “What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sebastian!” called a familiar voice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ignoring the towering mountain that was Detective Winter, I looked around him to see Neil walking through the shop, shaking snow from his coat. I was immediately both happy and frustrated to see him, which didn’t seem like the right response. I hadn’t called to tell him what happened, so there should have been no reason for his appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I turned to the counter. Max raised his hands up defensively and shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What’s going on?” Neil asked upon reaching us. He looked at the two other detectives and removed a badge from inside his coat. “Detective Millett, CSU.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lancaster didn’t seem interested. “Detective Lancaster, homicide,” she replied with a nod. “My partner, Winter. We haven’t requested forensics yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Homicide?” I echoed. I mean, sure, I guess technically a heart without a body could mean something more sinister was at work besides a medical cadaver showing up to class and some poor student flunking when he had no heart to dissect.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I looked at Neil. He seemed concerned and maybe nervous, and for a minute, I was happy because he was worried about me. The annoyance I had been harboring toward him all morning suddenly washed away, and I had the urge to reach out for a hug.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sebastian is—a friend,” Neil said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Friend")]), _vm._v(",” Winter repeated in a tone I didn’t like.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He called me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Goddamn it, Neil.")]), _vm._v(" He was so convinced he’d lose his shield for having a life outside his job, that after four years I was still just his "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("friend")]), _vm._v(" in public.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’re in the middle of asking Mr. Snow some questions,” Winter said before looking back at me. I swear his gaze was intense enough to strip me down to bare bones. “Mr. Rodriguez’s business was broken into Sunday night.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m sorry to hear that,” I answered, turning away from Neil. “Was anything stolen?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The investigation is still underway. He pointed a finger at you, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“M-Me?” I asked in surprise. “What—Mike thinks "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I")]), _vm._v(" broke in?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why would he say that?” Winter asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I have no idea,” I quickly answered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Where were you Sunday night?” Lancaster asked. “After eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I could feel Neil’s desperation rippling off his body. I had been at home with him. I believe around eight we had been fucking, which had ended prematurely and dissolved into an argument until about nine. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("That’s")]), _vm._v(" where I had been.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Home,” I said simply. “Look, I’m not answering any more questions without a lawyer, if that’s what I need. I called because I found a human heart in my shop, and now you’re accusing me of robbing someone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil’s hand was on my elbow next, and he was excusing us while dragging me away. Stopping near the back of the shop, he let go and turned to tower over me. “What the hell is going on?” he whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What’s going on?” I repeated. “What are you doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m a cop, Sebby—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t call me that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What human heart? Why didn’t you call me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I honestly hadn’t thought to ring Neil. Maybe a year or two earlier, the first reaction I’d have had would be to call my cop boyfriend to come solve this peculiar little problem. Now, he hadn’t even crossed my mind. It was disconcerting.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nice lie you told, by the way,” I said instead. “I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("called")]), _vm._v(" you? Why the hell did you come if it wasn’t to be here for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Stop it,” he ordered in a harsh whisper. “We’re not having this argument again.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Go back to work, Neil. Everything is fine,” I said stubbornly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You didn’t….” He hesitated.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Tell them about you? No. I know the drill.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil gritted his jaw. He looked angry. He turned back to the other detectives before saying, “Is that Calvin Winter?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What? Yeah, why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Be careful what you say to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Why")]), _vm._v(", Neil?” I repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Because I hear he’s a homophobe,” Neil said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Without thinking I replied, “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("You’re")]), _vm._v(" a homophobe.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil looked back at me with a strange expression I couldn’t place. “Real nice, Sebby,” he said after a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I couldn’t take it back, but when I stared up at Neil, when all of our recent arguments over the past month came rushing back, I didn’t care and didn’t want to take it back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Go back to work,” I said again. “We’ll talk at home, behind locked doors.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I was making him angry, and I couldn’t stop myself. I don’t know what had gotten into me lately. Neil and I had been at each other’s throats for weeks. I provoked him, or something he said got under my skin in ways it never did before.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil didn’t say another word. He turned while zipping up his coat and brushed by the other detectives in silence on his way out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I took a breath. It was shaky. I was being cruel to the most important man in my life.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I pushed my glasses up the bridge of my nose as Lancaster left the woman with the medical supplies and walked toward me with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Good news, Mr. Snow.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s not human.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Who, Neil?")]), _vm._v(" “The heart?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s a pig’s heart,” she replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A minor relief.” I took another breath, working harder than necessary to calm myself. “So can I open for business?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She spread her hands. “There’s been no foul play, although it seems like someone wanted to pull a prank on you. I highly suggest you invest in some tighter security.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("No foul play.")]), _vm._v(" My gut said otherwise. Two detectives—from homicide, no less—had shown up right away, and I played twenty questions regarding the unfortunate pig and Mike Rodriguez, the latter of which I found extremely strange. Why would time be wasted to send out detectives for something that proved to be nothing? And it still didn’t explain how the pig heart ended up in my shop to begin with.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lancaster thanked me for my time, to which I muttered some pleasantry. She turned to leave with the medical examiner.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Winter, however, approached me. “Your friend seemed upset.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I frowned while looking up. I was on the shorter side, only five foot nine, and both Neil and Winter stood a good half a foot taller. Neil was a leaner build, like myself, which was a stark contrast to the brick body that was Detective Winter. He was close enough again that I could study his freckles—which to me actually looked like gray blemishes. They’d be clearer if I invaded his personal space or looked at his skin with a magnifying glass.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neither of those do I recommend doing to someone you’ve just met.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("In comparison, his light-colored eyes were so brilliant and sharp, it was almost unnerving. They reminded me of minerals on display at the Museum of Natural History. They were gorgeous, but also maybe just a little weary. They looked like they’d seen something that had hardened and tired him considerably.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Winter swallowed up the air around me. He was both intimidating and somewhat comforting to be in the presence of. He smelled nice too. Some kind of spice—really different from Neil’s cologne.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I didn’t break into Mike’s shop,” I said again. For the record.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His gaze shifted slightly to the boxes behind me. “What’s all this?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I looked over my shoulder, then back at him. “New inventory.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“From where?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bond Antiques,” I retorted. “Jesus. It’s from an estate sale.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He reached into his suit coat next, and I wouldn’t have been surprised if he pulled his gun with the way I was shooting my mouth off. Instead, he handed me a business card. “Should you conveniently remember something.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Like slaughtering some pigs?” I shoved the card in my pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Have a good day, Mr. Snow.” He turned and walked out of the shop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THE STORM")]), _vm._v(" seemed to have scared off the day’s foot traffic, which on any other afternoon would have worried me, being so close to the holidays when the sales are needed. But I couldn’t concentrate on anything business-related. My salad sat beside me at the register, half eaten and getting soggy as it settled into the pool of vinaigrette dressing. I held a magnifying glass to the mail as I read.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why not get bifocals?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I looked up to see Max staring at me, pulling up the spare stool to sit. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The magnifying glass is sort of silly. You pull them out of pockets like you’re an old-timey detective.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I tripped down the stairs wearing bifocals when I was younger,” I answered while setting the glass aside and stacking the junk and bills together. “Broke my arm.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yikes.” Max reached out to push my salad around with the fork. If he planned on scalping my meal, the sogginess must have changed his mind. “So why was Neil here?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know.” I stood, brought the mail into the office, and dropped it on the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The morning had been resting heavily on my mind. Usually I was closed on Mondays, but holiday demands often changed my schedule, so I had been open yesterday. When I closed the shop last night just after six, it gave someone a thirteen-hour window to break inside. Max and I had spent the remaining hours of the morning going through the Emporium, and from what we could tell, not a single item had been misplaced.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("that")]), _vm._v(" concept that puzzled me the most. Why break into an antique shop, get past the security alarm, only to steal nothing?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So someone came in, put a decaying pig heart under the floorboards, and hightailed it without taking so much as an old button?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("More upsetting was the matter with Mike Rodriguez. I had worked for Mike for a few years before going into business for myself. I respected his knowledge and the success of his shop—he’d been in this line of work for over twenty years now—but he was a cranky old fuck. He hadn’t liked me all that much when I worked for him, and I’m certain he felt slighted, to say the least, when I took everything I had learned to open the Emporium.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mike specialized in higher-end antiques. Georgian and Victorian furniture, clothing, paintings, and other works of art. It wasn’t where my interests were, and the Emporium was cluttered and stuffed instead with books and old documents, maps, photos, and every little gizmo and gadget from another century. People enjoy the odd and bizarre, like Victorian glove stretchers or tear bottles. The Emporium was doing very well after only a few years of business, and I suspected Mike was insulted.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I walked back out of the office, leaned against the doorframe, and crossed my arms. Mike and I weren’t exactly on friendly terms these days—we certainly weren’t mailing each other Christmas cards—but how the hell had he come to the conclusion that I should be looked at as a possible suspect? Had he waited three years to seek revenge against me? And it wasn’t even revenge so much as insulting my integrity and character.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Man, look at it coming down,” Max murmured as he stared out toward the front door, watching the storm continue.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Jingle Bells” started to play on the shop’s speakers. Dashing through the snow, all right. The city was getting buried.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why don’t you get out of here early, Max.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. The subways are going to be a wreck, I bet,” I said while walking to the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you leaving?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Honestly, I wanted to swing by Mike’s place and ask him what was going on, but it didn’t seem like the smartest idea. Maybe I’d give him a call. That was less threatening. As much of an asshole as he was for accusing me of doing something like breaking into his place of business, we had a long history and I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("did")]), _vm._v(" want to make sure he was okay.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Probably.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll walk out with you, then,” Max replied as he stood and started cashing out the register for me.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The shop phone rang, and I reached to take it off the receiver. “Snow’s Antique Emporium.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Neil.")]), _vm._v(" I collected myself. “Hey.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Busy?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’re closing up early. The weather’s getting bad, and Max has to take the subway to Brooklyn.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m ducking out,” he replied. “I’ll swing by for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I can walk home.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil took an aggravated breath. “Sebby, please don’t argue with me just once this month, okay? Let me pick you up.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Why was I getting angry at him for wanting to drive me home instead of making me walk in this nasty weather? “All right. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Want me to grab anything for dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I thought I’d cook,” I said offhandedly. I was getting sick of takeout. Neil couldn’t cook to save his life, so it was up to me if we wanted a homemade meal.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That sounds great,” he replied happily. “I’ll be there in twenty, tops.” He hung up, and I put the phone down.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Neil’s coming to pick me up,” I said to Max. “I’ll finish closing. Why don’t you get out while you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Max laughed and finished his counting. “Thanks, Seb.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll call you tomorrow if the weather looks like we may have trouble opening.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll plan to come in unless I hear otherwise.” He was out the door within moments, disappearing into the storm.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I locked the front door and collected my belongings. I packed my laptop into my messenger bag. On the off-chance we stayed closed, I could at least start cataloging the inventory I had at home. Of course, I’d been telling myself that for two weeks and never seemed to have the energy for it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("By the time I’d shut off the lights, secured the shop, and changed into my winter attire, Neil’s black BMW was parked out front.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The car had been another source of aggravation between us. I don’t have a license because of the amount of work those with achromatopsia have to go through in order to be permitted to drive. It isn’t worth the headache when I live in a city with such incredible public transportation. That being said, I had agreed to buy a car with Neil and pay for it together so we could vacation out of New York every once in a while.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil has expensive taste. He wouldn’t settle on anything less than a new luxury coupe. I didn’t understand the point—we’d save so much money with a decent used car. That argument had ended with me saying that I’d refuse to help with the payments, to which he had stubbornly agreed and told me to fuck myself. Out of childish spite, I had tried to refuse every ride offered thus far.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The car was warm when I opened the door and sat in the passenger’s seat. The windshield wipers worked hard to keep the heavy, sticky snow off the glass. Neil was listening to some Christmas tunes and looking like his cool, sexy self. I had to admit he looked good behind the wheel of this car.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He smiled. “Ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yup.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil pulled back onto the road, taking it slow down the streets already buried in snow and brown slush. “You may get snowed in tomorrow if this keeps up like the weather predictions claim.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Will you have to go in?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Public servants don’t get snow days. Warm enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I muttered a response and fell silent. We lived in a cramped, too-small-for-two Manhattan apartment not far from my store. It wouldn’t usually take so long to reach, but the road was completely buried, and cars ahead were already slipping and sliding. Neil wasn’t taking chances by driving fast.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I looked at his profile, seeing the same handsome face I’d known for years. He told me he had brown eyes and sandy brown hair, comparing it to coffee with too much cream in it. Whatever the color, he had always been attractive to me, and he aged wonderfully. I saw the man I had fallen in love with, staring at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Why had we been fighting so much?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("My good old dad said it was because I was losing my mind being shoved back into the closet for the sake of Neil’s paranoia. I had denied it for years, that it would eventually make me nuts, but lately it seemed like Pop had been on to something. I had been out since college, and I was proud of who I was. Neil had been my first "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("serious")]), _vm._v(" relationship, and it had thrown me for a spin to learn he wasn’t out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It still threw me.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m sorry,” I said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“For what?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“For giving you attitude this morning.” I stared at my hands. “Why did you come to the Emporium?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He sighed. “I was in the right place to overhear detectives being dispatched to the address. I thought something was wrong—something happened to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thanks for being worried.” I snorted and shook my head. “That sounds weird.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I get what you mean.” He removed one hand briefly from the steering wheel to pat my thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("NEIL DROPPED")]), _vm._v(" me off on our street and went to find a place to park. I let myself into the building, hiking the three floors of old, rickety stairs to our one-bedroom apartment. The pipes were clanking loudly as the water heaters were turning on. I hung up my coat and hat and put my boots in the closet. I dropped my bag on the foot of our bed before turning on a few lamps around the apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I know Neil didn’t like living in such a dark home, but he was polite and dealt with it without a word of complaint so I didn’t need to wear sunglasses inside. I had tried to keep my condition a secret from him for a long time. It got really hard when he’d ask something like “Could you grab my navy blue button-down for me?” or “Pass the green salsa?” while eating Mexican. It ended up coming out when he found my collapsed walking stick in my bag one evening while searching for a condom.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I laughed quietly to myself, opening the fridge in the kitchen. That had killed the mood. I thought then and there he’d break up with me. Both boyfriends I had had before left me because of my condition. It wasn’t life-threatening, but it was a burden, I guess. Neil had stayed with me, though, and that mattered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I heard Neil at the door, removing his coat and shoes while I was chopping onions and peppers in the kitchen. I tossed the diced veggies into a pot to let them cook while I opened two cans of tomato sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Spaghetti?” Neil called, the smell familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We need to go shopping,” I answered. “Not many other options.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He stepped around me and opened the fridge. “Want a beer?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He popped the tops off two bottles, set one on the counter beside me, and leaned back against the opposite side. “So tell me what happened this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I recited the story again for what felt like the hundredth time while I doctored up the sauce with salt, pepper, Tabasco, and whatever spices I could find deep in the cupboard. “But it wasn’t human. It was a pig heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What did the detectives say?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I shrugged. “Lancaster told me to open for business and get better security.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And that Winter fellow?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I looked over my shoulder. “Why don’t you like him?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I told you why.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He let the questioning about Mike drop and left.” I had turned back to stir the sauce, but paused and looked at Neil. “You haven’t heard anything about that, have you? Mike’s break-in?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil shook his head before taking a swig of beer. “Someone else’s case, not mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why do you think Mike would accuse me of breaking into his store?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Because he’s a prick.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But nothing,” Neil interrupted. “He’s always had it out for you, Seb.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Taking a drink of beer, I considered my next comment. “I was thinking about giving him a call tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil stared at me as if I’d grown a second head. “You’re not stupid, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sebby, stay the hell out of it. Let the police investigate what happened to Mike, and don’t be an idiot and harass him.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who said anything about harassment? I was just going to see if he’s all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Doesn’t matter,” Neil replied. “The police don’t need to see you’ve been contacting him after he pointed his finger at you in the first place, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil had a valid point, of course, and who would know better what a cop would think than another cop?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Taking a drink and giving dinner my full attention, I zoned back in when I heard him saying my name.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Seb, promise you won’t stick your nose where it’s not supposed to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why do you think I will?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("That question made Neil laugh. “Because you like the thrill. The two hundred mystery novels on the bookcase in the living room say so.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t have "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("two")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("hundred")]), _vm._v(",” I said defensively. But so what? I liked a good brainteaser.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Seb,” he said again, more sternly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("won’t")]), _vm._v(",” I insisted, getting annoyed. “I get it.” Before Neil could say another word, I said, “How the heart ended up in the shop has yet to be explained.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hmm?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How’d a pig’s heart get under the floorboards, Neil?” I asked while turning. “I didn’t put it there, and I was the one to close up last night. I didn’t forget to lock the gate or set the alarm.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It was probably a prank,” he said simply, shrugging.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A prank?” I echoed. “By who?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t know. Kids—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("teenagers")]), _vm._v(". Someone sick in the head. Come on. You’ve been busy as hell at the Emporium. You and Max can’t keep an eye on everything all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Again, what Neil said could have very easily been true. Minus today, we had been slammed since before Thanksgiving. There was always a handful of customers roaming about at one time, inventory coming in, items going out for auction—I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("couldn’t")]), _vm._v(" always watch everything.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But what’s the point?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What’s the point of a hotdog-eating contest?” Neil countered with a laugh. “People do stupid things sometimes, Seb.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I guess. It’s a little dramatic, though. ‘The Tell-Tale Heart.’”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The what?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Poe,” I said. “It is the beating of his hideous heart!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh, yeah, I think I remember reading that in school,” Neil replied thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“An old man with a blind eye is murdered and cut up. The murderer thinks he hears the heart under the floorboards where he put the body,” I explained. “He goes mad with guilt while the police are there looking into a possible disturbance.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, damn.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Good thing I’m only legally blind,” I said sarcastically.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("NEIL AND")]), _vm._v(" I watched some police procedural drama while we ate, which really was just Neil complaining for forty-five minutes that the forensics team was handling the scene incorrectly, and "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("no one")]), _vm._v(" got DNA results back that quickly. Disgruntled, he ended up channel-surfing before finding "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Home Alone")]), _vm._v(" and settling on that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I always wanted to do this,” he said as we sat in the dark, sipping wine later in the evening.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Be Macaulay Culkin?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Catch bad guys,” Neil replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You do,” I pointed out. “Just with big-boy toys. You’re a little too old for tar on the stairs and BB guns.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil wrapped an arm around my shoulders, and I got comfortable in his embrace. It was nice to be enjoying the evening together and not fighting about stupid shit. Neil must have been thinking the same thing, because he leaned close and kissed the top of my head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey,” he murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, what?” I responded, looking up. Believe it or not, my vision was considerably better in the dark. Neil’s finer details were easier for me to see here.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why don’t we hightail it out of here?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“To where?” I laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The next room over.” Neil leaned forward, setting our glasses on the coffee table before getting to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I stood, taking Neil’s offered hand, and let him lead me into our cramped bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He stopped to put my bag against the wall and shut the door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Afraid someone will see?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He paused before turning to look at me. “To keep the cold air out, Seb,” he corrected in that voice I’d come to learn as the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Sebastian, you’re being irrational")]), _vm._v(" tone. I did not like it, because he used that tone on me whenever a discussion of his sexuality reared its ugly head.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil reached out, grabbed my waist and the back of my head, and kissed me hard. He tasted a little sweet and a little bitter, which about summed up our relationship. He had lost his suit coat and tie since arriving home, but I quickly helped with the remaining shirt and trousers. Neil was busy tossing aside my slacks and sweater when he laughed against my mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You dress like a grandpa,” he whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I like that sweater.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s older than you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m not trying to win a fashion contest.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Clothes shopping was stressful for me. Department stores were so bright, and there was apparently a concept of "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("clashing colors")]), _vm._v(". My idea of adding new options to my wardrobe was heading out to secondhand shops with Pop, letting him grab a dozen items in dark colors he says won’t hurt anyone’s eyes if I mix and match, then we’re out in ten minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’ll get you a nicer sweater,” Neil said, kissing my neck.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I like that one,” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s from Goodwill.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So? I don’t need some three hundred dollar Ralph Lauren sweater when that one does a fine job of keeping me warm,” I said defensively.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you done, Sebby?” Neil asked, pulling back to stare at me. “Do you really want to argue right now?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I didn’t, of course not. I was sick of fighting, tired of every conversation ending in one of us getting frustrated with the other. Staring at Neil in the near dark, a familiar and awful thought came to mind again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I wasn’t what he really wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was stupid shit like the sweater. What did it matter if I wore something a little frumpy? He wanted to have me wear something chic and fashionable, like the damn car.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Seb?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I shook my head, wrapped my arms around his neck, and kissed Neil, trying to get back into the mood.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("When was the moment our relationship turned?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He pushed me down onto the bed, kissing and sucking down my chest and stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("When we moved in together, maybe.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I was turned onto my belly, and the snap of a bottle preceded a warm, oily finger pressing into me.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("When had I grown so defensive? So bitter and resentful toward my partner?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Neil’s hands were on my hips, raising me up before he pushed in roughly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I gritted my teeth as he started thrusting.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I didn’t like who I had become.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0